import {
  AnalyticsLogo,
  CalendarLogo,
  ClassesLogo,
  InvoiceLogo,
  RetentionLogo,
  RevenueLogo,
  StaffLogo,
  WalletLogo,
  TransactionLogo,
} from "../../../../components/logos";
import React from "react";
import { ReportsTable } from "./table";
import { ActionButton } from "./actionButton";
import moment from "moment";
import CollapsibleTable from "./collapsibleTableReport";
import { api } from "../../../../api/api";
import { store } from "../../../../redux/storeConfig/store";
import { AccountingModal } from "../../../../components/modals/accountingModal";
import { setShowAccountingModal, setShowAIFeedbackModal, setShowSwitchStaffPaymentDetailsModal } from "../../../../redux/actions/reports/reportsAction";
import { ActionDetailsButton } from "./showDetailsActionButton";
import { cashesList } from "../../../../components/appointment/utils";
import { ConfirmCloseStaffSessionActionButton } from "./confirmCloseStaffSessionActionButton";
import { setEndStaffSessionModalOpen } from "../../../../redux/actions/staffSession/staffSessionAction";
import { Modal } from "reactstrap";
import {
  getAppointmentTypes,
  getGymCategories,
  getUniqueSuppliers,
  undoDeletionMemberApi,
} from "../../../../redux/actions/api/apiAction";
import title from "../../../../components/title";
import { FormatObjects } from "../../../../components/appointment/bookAppointment/utils";
import { ADMIN_ROLES } from "../../../../utils";
import { SwitchStaffPaymentDetailsModal } from "../../../../components/modals/switchStaffPaymentDetailsModal";
import { data } from "jquery";
import { AIFeedbackModal } from "../../../../components/modals/AIFeedbackModal";

export const currency = JSON.parse(
  localStorage.getItem("connectToFitGymPanelUser")
)?.currency;

export const packTypes = {
  class: "Classes",
  pt: "Appointments",
  GYM: "Gym",
};

const totalOptions = {
  AccountBalance: [
    {
      label: "OutStanding Balance Total",
      key: "outStandingTotal",
      show: () => true,
    },
    {
      label: "Remaining Amount Total",
      key: "remainingTotal",
      show: () => true,
    },
  ],
  AccountingEntry: [
    {
      label: "Total Recieved Amount",
      key: `grand_total_received_amount`,
      show: () => {
        return true;
      },
    },
    {
      label: "Total remaining ",
      key: "grand_total_remaining_amount",
      show: () => true,
    },
    {
      label: "Total Cash ",
      key: "grand_total_cash",
      show: () => true,
    },
    {
      label: "Total Visa ",
      key: "grand_total_visa",
      show: () => true,
    },
    {
      label: "Total Bank ",
      key: "grand_total_bank",
      show: () => true,
    },
    {
      label: "Total Comlimantry",
      key: "grand_total_complimantry",
      show: () => true,
    },
    {
      label: "Total Voided Amount",
      key: "grand_total_voided_amount",
      show: () => true,
    },
    {
      label: "Total Returned Amount",
      key: "grand_total_returned_amount",
      show: () => true,
    },
    {
      label: "Total Net Amount",
      key: "grand_total_net",
      show: () => true,
    },
  ],
  Members: [
    {
      label: "Total Members",
      key: "totalOfMembers",
      show: () => true,
    },
        {
      label: "Total Deleted Members",
      key: "totalDeletedMembers",
      show: () => true,
    },
    
    {
      label: "Expired Members",
      key: "totalExpiredMembers",
      show: () => true,
    },
    {
      label: "Rejoined Members",
      key: "totalRejoinedMembers",
      show: () => true,
    },
    {
      label: "Renewed Members",
      key: "totalRenewedMembers",
      show: () => true,
    },
    {
      label: "Existing Members",
      key: "totalExistingMembers",
      show: () => true,
    },
    {
      label: "New Members (No Package Purchased)",
      key: "totalNewMembersWithoutPackage",
      show: () => true,
    },
    {
      label: "New Members (Package Purchased)",
      key: "totalNewMembersWithPackage",
      show: () => true,
    },
    {
      label: "Freezed",
      key: "totalFreezedMembers",
      show: () => true,
    },
    {
      label: "Active Members",
      key: "totalActiveMembers",
      show: () => true,
    },
    {
      label: "inActive Members",
      key: "totalInActiveMembers",
      show: () => true,
    },
  ]
  ,
  Memberships: [
    {
      label: " Total",
      key: "totalMembers",
      show: () => true,
    },
    {
      label: "Expired",
      key: "totalExpired",
      show: () => true,
    },
    {
      label: "Freezed",
      key: "totalFreezed",
      show: () => true,
    },

    {
      label: "Complimentary",
      key: "totalComps",
      show: () => true,
    },
    // {
    //   label: "Rejoins",
    //   key: "totalRejoins",
    // },
    // {
    //   label: "Renew",
    //   key: "totalRenew",
    // },
  ],
  Sales: [
    {
      label: "Total amount of sales",
      key: `totalRecievedAmount`,
      show: () => {
        if (
          (store.getState().login.loginUser.role === "STAFF" &&
            !store.getState().permissions.permissions["SHO-TOTAL-S"]) ||
          (store.getState().permissions.subAdminType === "SUB_ADMIN" &&
            !store.getState().permissions.subAdminPermissions["SHO-TOTAL-S"])
        )
          return false;
        else return true;
      },
    },
    {
      label: "Total remaining ",
      key: "totalRemainingAmount",
      show: () => true,
    },
    {
      label: "Filtered amount ",
      key: "filterRecievedAmount",
      show: () => true,
    },
    {
      label: "Filtered Remaining amount ",
      key: "remainingAmount",
      show: () => true,
    },
    {
      label: "Joining Fees Amount ",
      key: "joiningFeesAmount",
      show: () => true,
    },
    {
      label: "Returned Amount",
      key: "returnAmount",
      show: () => true,
    },
  ],
  Revenue: [
    {
      label: "Total Net Reveue",
      key: "total_net_revenue",
      show: () => true,
    },
    {
      label: "Total Tax Amount",
      key: "total_tax",
      show: () => true,
    },
    {
      label: "Total Discount Amount",
      key: "total_discount",
      show: () => true,
    },
    {
      label: "Total Deffered Amount",
      key: "total_deffered",
      show: () => true,
    },
    {
      label: "Total Earned Amount",
      key: "total_earned",
      show: () => true,
    },
  ],
  PTRevenue: [
    {
      label: "Total Net Reveue",
      key: "total_net_revenue",
      show: () => true,
    },
    {
      label: "Total Tax Amount",
      key: "total_tax",
      show: () => true,
    },
    {
      label: "Total Discount Amount",
      key: "total_discount",
      show: () => true,
    },
    {
      label: "Total Deffered Amount",
      key: "total_deffered",
      show: () => true,
    },
    {
      label: "Total Earned Amount",
      key: "total_earned",
      show: () => true,
    },
    {
      label: "Total Earned Amount (from Attended)",
      key: "total_earned_attended",
      show: () => true,
    },
    {
      label: "Total Deffered Amount (from Attended)",
      key: "total_deffered_attended",
      show: () => true,
    },
  ],
  Transaction: [
    {
      label: "Total",
      key: "totalAmount",
      show: () => true,
    },
    {
      label: "Income",
      key: "income",
      show: () => true,
    },
    {
      label: "Outcome",
      key: "outcome",
      show: () => true,
    },
  ],
};
export const conditionalRowStyles = [
  {
    when: (row) =>
      row.isReturned == 1 || row.isVoided === 1 || row.isUpgraded === 1 || row.isSessionHasBalanceIssue == 1 || ["Missing", "Late", "Created Not Started"].includes(row.status),
    style: {
      backgroundColor: "rgba(255, 0, 0, 0.1)", // Light red background
      color: "red", // Red text
    },
  },
];
export const dayOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const addExtraColumnPerGymSettings = ({settings}) => {

    let extraFieldsForTable=[]
    let colsForExport=[]
    let valuesForExport={}
  if (settings?.memberRegistration?.fields?.middleName?.enabled) {
    extraFieldsForTable.push({
      name: "Middle Name",
      selector: (row) => row?.middleName || "Not available",
      sortable: true,
    });
    colsForExport.push("Middle Name")
    valuesForExport["Middle Name"]= (row) => row.middleName||"Not available"

  }
  if (settings?.memberRegistration?.fields?.maritalStatus?.enabled) {
    extraFieldsForTable.push({
      name: "Marital Status",
      selector: (row) => {
        let status = "Not Available";
        switch (row?.maritalStatus) {
          case "S":
            status = "Single";
            break;
          case "M": 
            status = "Married";
          default:
            break;
        }
        return status;
      },
      sortable: true,
    });
    colsForExport.push("Marital Status")
    valuesForExport["Marital Status"]= (row) => row?.maritalStatus==="S"?"Single":row?.maritalStatus==="M"?"Married":"Not Available"
  }
  if (settings?.memberRegistration?.fields?.homeAddress?.enabled) {
    extraFieldsForTable.push({
      name: "Home Address",
      selector: (row) => row?.homeAddress || "Not available",
      sortable: true,
    });
    colsForExport.push("Home Address")
    valuesForExport["Home Address"]= (row) => row.homeAddress||"Not available"
  }
  if (settings?.memberRegistration?.fields?.jobTitle?.enabled) {
    extraFieldsForTable.push({
      name: "Job Title",
      selector: (row) => row?.occupation || "Not available",
      sortable: true,
    });
    colsForExport.push("Job Title")
    valuesForExport["Job Title"]= (row) => row.occupation||"Not available"
  }
  if (settings?.memberRegistration?.fields?.companyName?.enabled) {
    extraFieldsForTable.push({
      name: "company Name",
      selector: (row) => row?.companyName || "Not available",
      sortable: true,
    });
    colsForExport.push("company Name")
    valuesForExport["company Name"]= (row) => row.companyName||"Not available"
  }
  if (settings?.memberRegistration?.fields?.emergencyContact?.enabled) {
    extraFieldsForTable.push({
      name: "Member's Emergency Contact Name",
      selector: (row) => row?.emergencyName || "Not available",
      sortable: true,
    });
    colsForExport.push("Member's Emergency Contact Name")
    valuesForExport["Member's Emergency Contact Name"]= (row) => row.emergencyName||"Not available"
     extraFieldsForTable.push({
      name: "Member's Emergency Contact Number",
      selector: (row) => row?.emergencyPhone || "Not available",
      sortable: true,
    });
    colsForExport.push("Member's Emergency Contact Number")
    valuesForExport["Member's Emergency Contact Number"]= (row) => row.emergencyPhone||"Not available"
  }
  extraFieldsForTable.push({
      name: "Action",
      width: "180px",
      selector: (row) =>
        row.isDeleted ? (
          <span
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => store.dispatch(undoDeletionMemberApi(row.id))}
          >
            {" "}
            Undo Deletion
          </span>
        ) : (
          "--"
        ),
      sortable: true,
  })
  return {extraFieldsForTable,colsForExport,valuesForExport}
}
const tabs = {
  members: [
    {
      id: 1,
      title: "Members",
      columns: [
        {
          name: "ID",
          selector: (row) => row.id || "MockData",
          sortable: true,
        },
        {
          name: "Name",
          selector: (row) =>
            row?.name ? (
              <span
                style={{
                  color: row.isDeleted ? "red" : "inherit",
                  fontWeight: row.isDeleted ? "bold" : "normal",
                }}
                title={row.isDeleted ? "Deleted Member" : ""}
              >
                {row?.name}
              </span>
            ) : (
              "Not Available"
            ),
          sortable: true,
        },
        {
          name: "Email",
          selector: (row) => row.email || "-",
          sortable: true,
        },
        {
          name: "Mobile",
          selector: (row) => row.phone || "-",
          sortable: true,
        },
        {
          name: "Gender",
          selector: (row) => row.gender || "Not Specified",
          sortable: true,
        },
        {
          name: "Member Status",
          selector: (row) => row?.memberStatus || "-",
          sortable: true,
        },
        {
          name: "Membership Status",
          selector: (row) => row.subscriptionStatus || "Active || Inactive",
          sortable: true,
        },        
        {
          name: "Member Registerd By",
          selector: (row) => {
            let registerBy="System"
            if(["F", "G", "T", "D", "A"].includes(row?.loginType))registerBy="App"
            else if (row?.loginType=="SR") registerBy="Self Registration"
            else if (row?.loginType=="TR") registerBy="Trainer"
            return registerBy
          },
          sortable: true,
        },
        {
          name: "Total Spent",
          selector: (row) => row.totalSpent || "0",
          sortable: true,
        },
        {
          name: "Joining Date",
          selector: (row) =>
            moment(row?.createdAt).format("DD-MM-YYYY hh:mm:ss A") || "0",
          sortable: true,
        },
        {
          name: "Last Updating Date",
          selector: (row) =>
            moment(row?.updatedAt).format("DD-MM-YYYY hh:mm:ss A") || "0",
          sortable: true,
        },
        {
          name: "Created By",
          width: "180px",
          selector: (row) => (row.createdBy ? row.createdBy : "--"),
          sortable: true,
        },
        {
          name: "Member Created Branch",
          width: "180px",
          selector: (row) => (row.branchName ? row.branchName : "--"),
          sortable: true,
        },
        {
          name: "Waver Signed",
          width: "180px",
          selector: (row) => (row?.isMobileVerfied||row?.isEmailVerified||row.acceptTermsAndConditions? "Yes" : "No"),
          sortable: true,
        },
   
      ],
    },
    {
      id: 2,
      title: "Memberships",
      columns: [
        {
          name: "Member",
          selector: (row) =>
            row.memberName ? (
              <span
                style={{
                  color: row.isDeleted ? "red" : "inherit",
                  fontWeight: row.isDeleted ? "bold" : "normal",
                }}
                title={row.isDeleted ? "Deleted Member" : ""}
              >
                {row.memberName}
              </span>
            ) : (
              "Not Available"
            ),
          sortable: true,
        },
        {
          name: "Member Phone",
          selector: (row) => row.phone || "",
          sortable: true,
        },
        {
          name: "Date of Birth",
          selector: (row) => row.dob || "",
          sortable: true,
        },
        {
          name: "Member Email",
          selector: (row) => row.email || "",
          sortable: true,
        },
        {
          name: "Member Status",
          selector: (row) => row.memberStatus || "",
          sortable: true,
        },        
        {
          name: "Package",
          selector: (row) => row.packageName || "MockData",
          sortable: true,
        },
        {
          name: "Starts",
          selector: (row) => row.startDate,
          format: (row) =>
            moment(row.startDate).format("DD-MM-YYYY hh:mm:ss A") || "MockData",
          sortable: true,
          sortFunction: (a, b) =>
            moment(a.startDate).unix() - moment(b.startDate).unix(),
        },
        {
          name: "Ends",
          selector: (row) => row.endDate,
          format: (row) =>
            moment(row.endDate).format("DD-MM-YYYY hh:mm:ss A") || "MockData",
          sortable: true,
          sortFunction: (a, b) =>
            moment(a.endDate).unix() - moment(b.endDate).unix(),
        },
        {
          name: "Membership Status",
          selector: (row) => row.subscriptionStatus || "Active || Inactive",
          sortable: true,
        },
        {
          name: "Check-ins",
          selector: (row) =>
            (
              <span>
                <b>
                  {row.checkins || 0} /
                  {row.sessionCount !== "unlimited"
                    ? ` ${row.sessionCount}`
                    : ` ${row.durationCount}`}
                </b>
                {row.sessionCount == "unlimited" && !row.isforTrainerOnly
                  ? " Days"
                  : ` Sessions`}
              </span>
            ) || "N/A",
          sortable: true,
        },
        {
          name: "Created By",
          width: "120px",
          selector: (row) => (row.createdBy ? row.createdBy : "--"),
          sortable: true,
        },
      ],
    },
  ],
  sales: [
    {
      id: 1,
      title: "Details",
      columns: [
        {
          name: "Sale Date",
          selector: (row) =>
            moment(row.createdAt).format("DD-MM-YYYY hh:mm:ss A") || "MockData",
          sortable: true,
          width: "150px",
        },
        {
          name: "Time",
          selector: (row) =>
            moment(row.createdAt).format("hh:mm A") || "MockData",
          sortable: true,
        },
        {
          name: "Client",
          width: "150px",
          selector: (row) =>
            row.memberName ? (
              <span
                style={{
                  color: row.isDeleted ? "red" : "inherit",
                  fontWeight: row.isDeleted ? "bold" : "normal",
                }}
                title={row.isDeleted ? "Deleted Member" : ""}
              >
                {row.memberName}
              </span>
            ) : (
              "Not Available"
            ),
          sortable: true,
        },
        {
          name: "Ref Id",
          selector: (row) => row.refId || "--",
          sortable: true,
        },
        {
          name: "Package/Product",
          width: "180px",

          selector: (row) => row.packageName || "MockData",
          sortable: true,
        },
        {
          name: "Quantity",
          with: "100px",
          selector: (row) => row.quantity,
          sortable: true,
        },
        {
          name: `Price`,
          selector: (row) =>
            `${(row?.paymentType == "CO"
              ? row?.packagePrice
              : row.purchasedPackagePrice) * row.quantity} ${currency ||
              "JOD"}` || 0,
          sortable: true,
        },
        {
          name: `Price(Tax Free)`,
          selector: (row) => {
            return `${parseFloat(
              (
                (row.purchasedPackagePrice * row.quantity) /
                (1 + row.tax / 100)
              ).toFixed(2)
            )} ${currency || "JOD"}`;
          },
          sortable: true,
        },
        {
          name: `Discount`,
          selector: (row) => {
            const discountedAmount = parseFloat(
              (
                ((row?.paymentType == "CO" ? 100 : row.discount) *
                  (row?.paymentType == "CO"
                    ? row?.packagePrice
                    : row.purchasedPackagePrice) *
                  row.quantity) /
                100
              ).toFixed(2)
            );
            return `${discountedAmount} ${currency || "JOD"}`;
          },
          sortable: true,
        },
        {
          name: `Subtotal`,
          selector: (row) => {
            const discountedAmount =
              (row.purchasedPackagePrice * row.quantity * row.discount) / 100;
            return `${row.purchasedPackagePrice * row.quantity -
              discountedAmount} ${currency || "JOD"}`;
          },

          sortable: true,
        },
        {
          name: `Cost `,
          selector: (row) => {
            return `${row?.cost || 0} ${currency || "JOD"}`;
          },

          sortable: true,
        },
        {
          name: `Payment Type `,
          selector: (row) => {
            let type;
            switch (row.paymentType) {
              case "CC":
                type = "Visa";
                break;
              case "L":
                type = "Cash";
                break;
              case "BA":
                type = "Bank";
                break;
              case "CO":
                type = "Complimentary";
                break;
              case "SP":
                type = "Split";
                break;
              default:
                type = "";
            }
            return `${type}`;
          },

          sortable: true,
        },
        {
          name: `Category `,
          selector: (row) => {
            return `${row?.category || ""}`;
          },

          sortable: true,
        },
        {
          name: `Joining Fees`,
          selector: (row) => `${row?.joiningFees} ${currency || "JOD"}`,
          sortable: true,
        },

        {
          name: `Tax`,
          with: "90px",
          selector: (row) => {
            const discountedAmount =
              row.purchasedPackagePrice *
              row.quantity *
              (1 - row.discount / 100);
            const taxPercentage = 1 + row.tax / 100;
            let tax = discountedAmount * (1 - 1 / taxPercentage);
            tax = parseFloat(tax.toFixed(2));
            return `${tax} ${currency || "JOD"}`;
          },
          sortable: true,
        },
        {
          name: "Net",
          with: "90px",
          selector: (row) => {
            const taxPercentage = 1 + row.tax / 100;
            const discountedAmount =
              row.purchasedPackagePrice *
              row.quantity *
              (1 - row.discount / 100);
            const tax = discountedAmount * (1 - 1 / taxPercentage);
            let netRevenue = discountedAmount - tax;
            netRevenue = parseFloat(netRevenue.toFixed(2));
            return `${netRevenue} ${currency || "JOD"}`;
          },

          sortable: true,
        },
        {
          name: `Assigned Sale Produt`,
          width: "150px",
          selector: (row) => `${row?.assignedSale ? row.assignedSale : ""}`,
          sortable: true,
        },

        {
          name: "Created By",
          width: "120px",
          selector: (row) => (row.createdBy ? row.createdBy : "--"),
          sortable: true,
        },
        {
          name: "Trainer",
          width: "100px",
          selector: (row) => (row.assignedTrainer ? row.assignedTrainer : "--"),
          sortable: true,
        },
        {
          name: "Notes",
          width: "250px",

          selector: (row) =>
            row.isVoided
              ? "Voided"
              : row.isReturned == 1
                ? row.note
                  ? ` Returned Amount ${row?.returnAmount ? row.returnAmount : ""
                  } - Return Reason : ${row?.note}`
                  : ` Returned Amount ${row?.returnAmount ? row.returnAmount : ""
                  }`
                : row?.note
                  ? row?.note
                  : "N/A",
          sortable: true,
        },
      ],
    },
    // {
    //   id: 2,
    //   title: "Summary",
    //   columns: [
    //     {
    //       name: "Package Name",
    //       selector: (row) => row.package.name || "MockData",
    //       sortable: true,
    //     },
    //     {
    //       name: "price",
    //       selector: (row) => row.price || "MockData",
    //       sortable: true,
    //     },
    //     {
    //       name: "Quantity",
    //       selector: (row) => row.quantity || "MockData",
    //       sortable: true,
    //     },
    //     {
    //       name: "Total Revenue",
    //       selector: (row) => row.totalRevenue || "MockData",
    //       sortable: true,
    //     },
    //   ],
    // },
  ],
  payroll: [
    {
      id: 1,
      title: "Details",
      columns: [
        {
          name: "User Id",
          selector: (row) => row.userId || "Not Available",
          sortable: true,
        },
        {
          name: "User Name",
          selector: (row) => row.name || "MockData",
          sortable: true,
        },
        {
          name: "User Balance",
          width: "150px",

          selector: (row) => (row?.balance ? row.balance.toFixed(2) : "0"),
          sortable: true,
        },

        {
          name: "Earned Amount",
          width: "180px",

          selector: (row) => row?.earnedAmount?.toFixed(2) || "0",
          sortable: true,
        },
        {
          name: "Deffered Amount",
          selector: (row) => row?.deferredAmount?.toFixed(2) || "0",
          sortable: true,
        },
      ],
    },
    // {
    //   id: 2,
    //   title: "Summary",
    //   columns: [
    //     {
    //       name: "Package Name",
    //       selector: (row) => row.package.name || "MockData",
    //       sortable: true,
    //     },
    //     {
    //       name: "price",
    //       selector: (row) => row.price || "MockData",
    //       sortable: true,
    //     },
    //     {
    //       name: "Quantity",
    //       selector: (row) => row.quantity || "MockData",
    //       sortable: true,
    //     },
    //     {
    //       name: "Total Revenue",
    //       selector: (row) => row.totalRevenue || "MockData",
    //       sortable: true,
    //     },
    //   ],
    // },
  ],
  accountEntry: [
    {
      id: 1,
      title: "Details",
      columns: [
        {
          name: "Services",
          selector: (row) => row?.category || "MockData",
          sortable: true,
          cell: (row) => {
            return (
              <div
                style={{ cursor: "pointer", color: "blue" }}
                onClick={async () => {
                  await store.dispatch(
                    setShowAccountingModal({ [row.category]: true })
                  );
                }}
              >
                {`${row?.category} ++ ` || "MockData"}
                {console.log(
                  store.getState().report.showAccountingDetails,
                  "re"
                )}
                <ActionDetailsButton category={row.category} />
              </div>
            );
          },
        },
        {
          name: "Totals",
          selector: (row) => row?.total_subscriptions?.toLocaleString() || "0",
          sortable: true,
        },
        {
          name: "Total Discount",
          selector: (row) => row?.total_discount?.toLocaleString() || "0",
          sortable: true,
        },
        {
          name: "Total Net",
          selector: (row) => row?.total_net_revenue?.toLocaleString() || "0",
          sortable: true,
        },
        {
          name: "Total Recevied Amount",
          selector: (row) => row?.total_received_amount?.toLocaleString() || "0",
          sortable: true,
        },
        {
          name: "Total Voided Amount",
          selector: (row) => row?.total_voided_amount?.toLocaleString() || "0",
          sortable: true,
        },
        {
          name: "Total Returned Amount",
          selector: (row) => row?.total_returned_amount?.toLocaleString() || "0",
          sortable: true,
        },

        {
          name: "Total Cash Amount",
          selector: (row) => row?.total_cash?.toLocaleString() || "0",
          sortable: true,
        },
        {
          name: "Total Visa Amount",
          selector: (row) => row?.total_visa?.toLocaleString() || "0",
          sortable: true,
        },
        {
          name: "Total Bank Amount",
          selector: (row) => row?.total_bank?.toLocaleString() || "0",
          sortable: true,
        },
        {
          name: "Total Complimantry Amount",
          selector: (row) => row?.total_complimantry?.toLocaleString() || "0",
          sortable: true,
        },
        {
          name: "Total Remaining Amount",
          selector: (row) =>
            row?.total_remaining_amount?.toLocaleString() || "0",
          sortable: true,
        },
      ],
    },
    // {
    //   id: 2,
    //   title: "Summary",
    //   columns: [
    //     {
    //       name: "Package Name",
    //       selector: (row) => row.package.name || "MockData",
    //       sortable: true,
    //     },
    //     {
    //       name: "price",
    //       selector: (row) => row.price || "MockData",
    //       sortable: true,
    //     },
    //     {
    //       name: "Quantity",
    //       selector: (row) => row.quantity || "MockData",
    //       sortable: true,
    //     },
    //     {
    //       name: "Total Revenue",
    //       selector: (row) => row.totalRevenue || "MockData",
    //       sortable: true,
    //     },
    //   ],
    // },
  ],
  attendence: [
    {
      id: 1,
      title: "Instructor",
      columns: [
        {
          name: "Instructor Name",
          selector: (row) => row.InstructorName || "Not available",
          sortable: true,
        },
        {
          name: "Service",
          selector: (row) => row.ServiceName || "Not available",
          sortable: true,
        },
        {
          name: "Service Type",
          selector: (row) => row.ServiceType || "Not available",
          sortable: true,
        },
        {
          name: "Total Members",
          selector: (row) => row.TotalMember || "0",
          sortable: true,
        },
      ],
    },
    {
      id: 2,
      title: "Classes",
      columns: [
        {
          name: "Name",
          selector: (row) => row.name || "MockData",
          sortable: true,
        },
        {
          name: "Day(Time)",
          selector: (row) => row.dayConverted || "MockData",
          sortable: true,
        },
        {
          name: "Total members",
          selector: (row) => row.checkinCount || "0",
          sortable: true,
        },
      ],
    },
    {
      id: 3,
      title: "Gym",
      columns: [
        {
          name: "Time",
          selector: (row) => row.time_range || "MockData",
          sortable: true,
        },
        {
          name: "number of checkins",
          selector: (row) => row.checkin_count || "0",
          sortable: true,
        },
      ],
    },
  ],
  staff: [
    {
      id: 1,
      title: "staff log",
      columns: [
        {
          name: "ID",
          selector: (row) => row.id || "MockData",
          sortable: true,
        },
        {
          name: "Name",
          selector: (row) => row.name || "MockData",
          sortable: true,
        },
        {
          name: "Date",
          selector: (row) => moment(Number(row?.checkin)).format("DD/MM/YYYY") || "MockData",
          sortable: true,
        },
        {
          name: "Day",
          selector: (row) => moment(Number(row?.checkin)).format("dddd") || "MockData",
          sortable: true,
        },
        {
          name: "Check-In",
          selector: (row) => moment(Number(row?.checkin)).format("hh:mm:ss A") || "MockData",
          sortable: true,
        },
        {
          name: "Check-out",
          selector: (row) =>
          row?.checkout?   moment(Number(row?.checkout)).format("hh:mm:ss A") : "",
          sortable: true,
        },
      ],
    },
  ],
  accountsBalance: [
    {
      id: 1,
      title: "AccountBalance",
      columns: [
        {
          name: "Client Name",
          selector: (row) =>
            row?.name ? (
              <span
                style={{
                  color: row.isDeleted ? "red" : "inherit",
                  fontWeight: row.isDeleted ? "bold" : "normal",
                }}
                title={row.isDeleted ? "Deleted Member" : ""}
              >
                {row?.name}
              </span>
            ) : (
              "Not Available"
            ),
          sortable: true,
        },
        {
          name: "OutStanding Balance",
          selector: (row) => row.outstandingBalance?.toLocaleString() || "0",
          sortable: true,
        },
        {
          name: "Received Amount",
          selector: (row) => row.recievedAmount?.toLocaleString() || "0",
          sortable: true,
        },
        {
          name: "Total Payment Due",
          selector: (row) => row.totalPaymentDue?.toLocaleString() || "0",
          sortable: true,
        },
        {
          name: "Actions",
          selector: (row) => (
            <ActionButton id={row.id} membership={row.membership} />
          ),
          sortable: true,
        },
      ],
    },
  ],
  booking: [
    {
      id: 1,
      title: "Booking",
      columns: [
        {
          name: "Instructor Name",
          selector: (row) => row.InstructorName || "MockData",
          sortable: true,
        },
        {
          name: "Service",
          selector: (row) => row.ServiceName || "MockData",
          sortable: true,
        },
        {
          name: "Service Type",
          selector: (row) => row.ServiceType || "MockData",
          sortable: true,
        },
        {
          name: "Total Members",
          selector: (row) => row.TotalMember || "0",
          sortable: true,
        },
      ],
    },
  ],
  revenue: [
    {
      id: 1,
      title: "Gym subscriptions Revenue",
      columns: [
        {
          name: "Member",
          width: "150px",
          selector: (row) =>
            row?.memberName ? (
              <span
                style={{
                  color: row.isDeleted ? "red" : "inherit",
                  fontWeight: row.isDeleted ? "bold" : "normal",
                }}
                title={row.isDeleted ? "Deleted Member" : ""}
              >
                {row?.memberName}
              </span>
            ) : (
              "Not Available"
            ),
          sortable: true,
        },
        {
          name: "Transfered to",
          width: "150px",
          selector: (row) =>
            row?.toMemberName ? (
              <span
                style={{
                  color: row.isDeleted ? "red" : "inherit",
                  fontWeight: row.isDeleted ? "bold" : "normal",
                }}
                title={row.isDeleted ? "Deleted Member" : ""}
              >
                {row?.toMemberName}
              </span>
            ) : (
              "---"
            ),
          sortable: true,
        },
        {
          name: "Package Name ",
          width: "400px",
          selector: (row) => row.packageName || "GYM",
          sortable: true,
        },
        {
          name: "Created Date",
          selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY") || "",
          sortable: true,
        },
        {
          name: "Start Date",
          selector: (row) => moment(row?.startDate).format("DD/MM/YYYY") || "",
          sortable: true,
        },
        {
          name: "End Date",
          selector: (row) => moment(row?.endDate).format("DD/MM/YYYY") || "",
          sortable: true,
        },

        {
          name: "Type",
          selector: (row) => packTypes[row.planType] || "GYM",
          sortable: true,
        },
        {
          name: "Price",
          selector: (row) =>
            `${parseFloat(row.purchasedPackagePrice || "0")
              .toFixed(2)
              ?.toLocaleString()}${currency || "JOD"}`,

          sortable: true,
        },
        {
          name: "Discount",
          selector: (row) => `${row.discount}%` || "2.5 JOD",
          sortable: true,
        },
        {
          name: "Tax(%)",
          selector: (row) => `${row.tax}%`,
          sortable: true,
        },
        {
          name: `Tax amount`,
          selector: (row) => row.taxAmount,
          sortable: true,
        },
        {
          name: "Net Revenue",
          selector: (row) => row.netRevenue.toLocaleString(),
          sortable: true,
        },
        {
          name: "Used",
          selector: (row) => row.usedSessions || "0",
          sortable: true,
        },
        {
          name: "Remaining",
          selector: (row) => row.remainingSessions || "0",
          sortable: true,
        },
        {
          name: "Earned $",
          selector: (row) =>
            `${row.earned?.toLocaleString() || "0"} ${currency || "JOD"}`,
          sortable: true,
        },
        {
          name: "Deffered $",
          selector: (row) =>
            `${row.deffered?.toLocaleString() || "0"} ${currency || "JOD"}`,
          sortable: true,
        },
        // {
        //   name: "Class Name",
        //   width: "200px",
        //   selector: (row) => row?.className || "---",
        //   sortable: true,
        // },
        // {
        //   name: "Intructor Name",
        //   width: "200px",
        //   selector: (row) => row?.trainerName || "---",
        //   sortable: true,
        // },
      {
          name: "Notes",
          width:"250px",
          selector: (row) => {
            return row.isvoided
              ? "Voided"
              : row.isUpgraded
                ? "Upgraded"
                : row?.transferedToId
                ?`Transfered at ${moment(row.transferedDate).format("DD/MM/YYYY")}`
                : "N/A";
          },
          sortable: true,
        },
      ],
    },
        {
      id: 2,
      title: "PT subscriptions Revenue",
      columns: [
        {
          name: "Member",
          width: "150px",
          selector: (row) =>
            row?.memberName ? (
              <span
                style={{
                  color: row.isDeleted ? "red" : "inherit",
                  fontWeight: row.isDeleted ? "bold" : "normal",
                }}
                title={row.isDeleted ? "Deleted Member" : ""}
              >
                {row?.memberName}
              </span>
            ) : (
              "Not Available"
            ),
          sortable: true,
        },
        {
          name: "Transfered to",
          width: "150px",
          selector: (row) =>
            row?.toMemberName ? (
              <span
                style={{
                  color: row.isDeleted ? "red" : "inherit",
                  fontWeight: row.isDeleted ? "bold" : "normal",
                }}
                title={row.isDeleted ? "Deleted Member" : ""}
              >
                {row?.toMemberName}
              </span>
            ) : (
              "---"
            ),
          sortable: true,
        },
        {
          name: "Package Name",
          width: "400px",
          selector: (row) => row.packageName || "PT-With Salah",
          sortable: true,
        },
        {
          name: "Created Date",
          selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY") || "",
          sortable: true,
        },
        {
          name: "Start Date",
          selector: (row) => moment(row?.startDate).format("DD/MM/YYYY") || "",
          sortable: true,
        },
        {
          name: "End Date",
          selector: (row) => moment(row?.endDate).format("DD/MM/YYYY") || "",
          sortable: true,
        },

        {
          name: "Type",
          selector: (row) => packTypes[row.planType] || "Appointments",
          sortable: true,
        },
        {
          name: "Price",
          selector: (row) =>
            `${parseFloat(row.purchasedPackagePrice || "0")
              .toFixed(2)
              ?.toLocaleString()}${currency || "JOD"}`,

          sortable: true,
        },
        {
          name: "Discount",
          selector: (row) => `${row.discount}%` || "2.5 JOD",
          sortable: true,
        },
        {
          name: "Tax(%)",
          selector: (row) => `${row.tax}%`,
          sortable: true,
        },
        {
          name: `Tax amount`,
          selector: (row) => row.taxAmount,
          sortable: true,
        },
        {
          name: "Net Revenue",
          selector: (row) => row.netRevenue.toLocaleString(),
          sortable: true,
        },
        {
          name: "Booked Sessions",
          selector: (row) => row.usedSessions || "0",
          sortable: true,
          tooltip: "Total number of sessions booked (past + future)."

        },
        {
          name: "Completed Sessions ",
          selector: (row) => row?.completedBookingsCount || "0",
          sortable: true,
        }
        ,
        {
          name: "Attended Sessions ",
          selector: (row) => row?.checkedInCount || "0",
          sortable: true,
        },          
        {
          name: "Remaining",
          selector: (row) => row.remainingSessions || "0",
          sortable: true,
        },
        {
          name: "Earned from Completed Sessions $",
          selector: (row) =>
            `${row.earned?.toLocaleString() || "0"} ${currency || "JOD"}`,
          sortable: true,
        },
        {
          name: "Earned Value (from Attended) Sessions $",
          selector: (row) =>
            `${row.earnedFromCheckIn?.toLocaleString() || "0"} ${currency || "JOD"}`,
          sortable: true,
        },        
        {
          name: "Deffered from Completed Sessions $",
          selector: (row) =>
            `${row.deffered?.toLocaleString() || "0"} ${currency || "JOD"}`,
          sortable: true,
        },
        {
          name: "Deffered (from Attended) Sessions $",
          selector: (row) =>
            `${row.defferedFromCheckIn?.toLocaleString() || "0"} ${currency || "JOD"}`,
          sortable: true,
        },        
        {
          name: "Intructor Name",
          width: "200px",
          selector: (row) => row?.trainerName || "Sale Not Assigend To Instructor",
          sortable: true,
        },
        {
          name: "Notes",
          width:"250px",
          selector: (row) => {
            return row.isvoided
              ? "Voided"
              : row.isUpgraded
                ? "Upgraded"
                : row?.transferedToId
                ?`Transfered at ${moment(row.transferedDate).format("DD/MM/YYYY")}`
                : "N/A";
          },
          sortable: true,
        },
      ],
    },
        {
      id: 3,
      title: "Class subscriptions Revenue",
      columns: [
        {
          name: "Member",
          width: "150px",
          selector: (row) =>
            row?.memberName ? (
              <span
                style={{
                  color: row.isDeleted ? "red" : "inherit",
                  fontWeight: row.isDeleted ? "bold" : "normal",
                }}
                title={row.isDeleted ? "Deleted Member" : ""}
              >
                {row?.memberName}
              </span>
            ) : (
              "Not Available"
            ),
          sortable: true,
        },
        {
          name: "Service",
          width: "400px",
          selector: (row) => row.packageName || "PT-With Salah",
          sortable: true,
        },
        {
          name: "Created Date",
          selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY") || "",
          sortable: true,
        },
        {
          name: "Start Date",
          selector: (row) => moment(row?.startDate).format("DD/MM/YYYY") || "",
          sortable: true,
        },
        {
          name: "End Date",
          selector: (row) => moment(row?.endDate).format("DD/MM/YYYY") || "",
          sortable: true,
        },

        {
          name: "Type",
          selector: (row) => packTypes[row.planType] || "Appointments",
          sortable: true,
        },
        {
          name: "Price",
          selector: (row) =>
            `${parseFloat(row.purchasedPackagePrice || "0")
              .toFixed(2)
              ?.toLocaleString()}${currency || "JOD"}`,

          sortable: true,
        },
        {
          name: "Discount",
          selector: (row) => `${row.discount}%` || "2.5 JOD",
          sortable: true,
        },
        {
          name: "Tax(%)",
          selector: (row) => `${row.tax}%`,
          sortable: true,
        },
        {
          name: `Tax amount`,
          selector: (row) => row.taxAmount,
          sortable: true,
        },
        {
          name: "Net Revenue",
          selector: (row) => row.netRevenue.toLocaleString(),
          sortable: true,
        },
        {
          name: "Used",
          selector: (row) => row.usedSessions || "0",
          sortable: true,
        },
        {
          name: "Remaining",
          selector: (row) => row.remainingSessions || "0",
          sortable: true,
        },
        {
          name: "Earned $",
          selector: (row) =>
            `${row.earned?.toLocaleString() || "0"} ${currency || "JOD"}`,
          sortable: true,
        },
        {
          name: "Deffered $",
          selector: (row) =>
            `${row.deffered?.toLocaleString() || "0"} ${currency || "JOD"}`,
          sortable: true,
        },
        {
          name: "Class Name",
          width: "200px",
          selector: (row) => row?.className || "---",
          sortable: true,
        },
        {
          name: "Intructor Name",
          // width: "200px",
          selector: (row) => row?.trainerName || "Sale Not Assigend To Instructor",
          sortable: true,
        },
        {
          name: "Notes",
          width:"250px",
          selector: (row) => {
            return row.isvoided
              ? "Voided"
              : row.isUpgraded
                ? "Upgraded"
                : row?.transferedToId
                ?`Transfered at ${moment(row.transferedDate).format("DD/MM/YYYY")}`
                : "N/A";
          },
          sortable: true,
        },
      ],
    },
  ],
  transaction: [
    {
      id: 7,
      title: "Transaction",
      columns: [
        {
          name: "id",
          width: "150px",
          selector: (row) => row.id || "Not Available",
          sortable: true,
        },
        {
          name: "Membership",
          selector: (row) => row.membership || "Not Available",
          sortable: true,
        },
        {
          name: "Start Subscription",
          selector: (row) =>
            row?.startDate
              ? moment(row?.startDate).format("DD-MM-YYYY hh:mm:ss A")
              : "",
          sortable: true,
        },
        {
          name: "End Subscription",
          selector: (row) =>
            row?.endDate
              ? moment(row?.endDate).format("DD-MM-YYYY hh:mm:ss A")
              : "",
          sortable: true,
        },
        {
          name: "Payment Type",
          selector: (row) => row.purpose || "Not Available",
          sortable: true,
        },
        {
          name: "Transaction Type",
          selector: (row) => {
            let type;
            switch (row.type) {
              case "CC":
                type = row.CCType || "Visa";
                break;
              case "CQ":
                type = "Cheque";
                break;
              case "L":
                type = "Cash";
                break;
              case "CO":
                type = "complimentary";
                break;
              case "BA":
                type = "Bank";
                break;

              default:
                break;
            }
            return type;
          },
          sortable: true,
        },
        {
          name: "Counterparty",
          width: "200px",
          selector: (row) =>
            row.financialParty ? (
              <span
                style={{
                  color: row.isDeleted ? "red" : "inherit",
                  fontWeight: row.isDeleted ? "bold" : "normal",
                }}
                title={row.isDeleted ? "Deleted Member" : ""}
              >
                {row.financialParty}
              </span>
            ) : (
              "Not Available"
            ),
          sortable: true,
        },
        {
          name: "Amount",
          selector: (row) => row.amount?.toLocaleString() || "0",
          sortable: true,
        },
        {
          name: "Created By",
          selector: (row) => row?.name|| "---",
          sortable: true,
        },
        {
          name: "Created At",
          selector: (row) =>
            moment(parseInt(row?.createdAt)).format("DD-MM-YYYY hh:mm:ss A"),
          sortable: true,
        },
        {
          name: "Note",
          selector: (row) => row?.note || "----------",
          sortable: true,
        },
      ],
    },
  ],
  canceledMemberships: [
    {
      id: 7,
      title: "Canceled Memberships",
      columns: [
        {
          name: "id",
          width: "150px",
          selector: (row) => row.id || "Not Available",
          sortable: true,
        },
        {
          name: "Member",
          selector: (row) =>
            row.member ? (
              <span
                style={{
                  color: row.isDeleted ? "red" : "inherit",
                  fontWeight: row.isDeleted ? "bold" : "normal",
                }}
                title={row.isDeleted ? "Deleted Member" : ""}
              >
                {row.member}
              </span>
            ) : (
              "Not Available"
            ),
          sortable: true,
        },
        {
          name: "Package",
          selector: (row) => row?.package || "Not Available",
          sortable: true,
        },
        {
          name: "Price",
          selector: (row) => row?.price || "0",
          sortable: true,
        },
        {
          name: "Receieved Amount",
          selector: (row) => row?.recievedAmount || "0",
          sortable: true,
        },
        {
          name: "Voided Amount",
          selector: (row) => row?.returnedAmoun || "0",
          sortable: true,
        },
        {
          name: "Canceled Date",
          selector: (row) =>
            moment(parseInt(row?.createdAt)).format("DD-MM-YYYY hh:mm:ss A") ||
            "Not Available",
          sortable: true,
        },
        {
          name: "Canceled By",
          selector: (row) => row?.voidedBy || "Not Available",
          sortable: true,
        },
        {
          name: "Notes",
          selector: (row) => {
            return row.paymentType == "upgrade" ? "Upgrade" : row?.note;
          },
          sortable: true,
        },
      ],
    },
  ],
  staffSessions: [
    {
      id: 9,
      title: "Staff Sessions",
      columns: [
        {
          name: "ID",
          selector: (row) => row.id || "N/A",
          sortable: true,
        },
        {
          name: "Staff Name",
          selector: (row) => row.createdBy.name || "N/A",
          sortable: true,
        },
        {
          name: "Cash",
          selector: (row) => {
            let cashName;
            cashesList.forEach((c) => {
              if (c.id == row.cash) {
                cashName = c.label;
              }
            });
            return cashName || "N/A";
          },
          sortable: true,
        },
        {
          name: "Status",
          selector: (row) => row.status || "N/A",
          sortable: true,
        },
        {
          name: "Start Date",
          selector: (row) =>
            moment(row.startTime).format("DD-MM-YYYY") || "",
          sortable: true,
        },
        {
          name: "End Date",
          selector: (row) =>
            row.endTime
              ? moment(row.endTime).format("DD-MM-YYYY")
              : "",
          sortable: true,
        },
        {
          name: "Start Time",
          selector: (row) => moment(row.startTime).format("hh:mm A") || "",
          sortable: true,
        },
        {
          name: "End Time",
          selector: (row) =>
            row.endTime ? moment(row.endTime).format("hh:mm A") : "",
          sortable: true,
        },
        {
          name: "Cash At Start",
          selector: (row) => row.startCashOnSiteAmount?.toLocaleString(),
          sortable: true,
        },
        {
          name: "Cash At End",
          selector: (row) => row.endCashOnSiteAmount?.toLocaleString(),
          sortable: true,
        },
        {
          name: "Cash Confirmed Amount",
          selector: (row) => row.cashOnSiteConfirmedAmount?.toLocaleString(),
          sortable: true,
        },
        {
          name: "Net Transactions",
          selector: (row) => {
            let total = 0;
            for (let i = 0; i < row?.userPaymentDetails.length; i++) {
              const p = row?.userPaymentDetails[i];
              total = total + p.amount;
            }
            return total?.toLocaleString();
          },
          sortable: true,
          cell: (row) => {
            let total = 0;
            for (let i = 0; i < row?.userPaymentDetails.length; i++) {
              const p = row?.userPaymentDetails[i];
              total = total + p.amount;
            }
            return (
              <div
                style={{ cursor: "pointer", color: "blue" }}
                onClick={async () => {
                  await store.dispatch(
                    setShowSwitchStaffPaymentDetailsModal({ [row.id]: true, data: row.userPaymentDetails })
                  );
                }}
              >
                {total?.toLocaleString()}
                <SwitchStaffPaymentDetailsModal id={row.id} data={row.userPaymentDetails} />
              </div>
            );
          },
        },
        {
          name: "Total In Cash",
          selector: (row) => {
            let total = 0;
            for (let i = 0; i < row?.userPaymentDetails.length; i++) {
              const p = row?.userPaymentDetails[i];
              total = total + p.amount;
            }
            const totalInCash = total + row.startCashOnSiteAmount;
            return (<span style={{ color: "green" }}>{totalInCash?.toLocaleString()}</span>);
          },
          sortable: true,
        },
        {
          name: "Difference In Cash",
          selector: (row) => {
          let totalCashSales = 0;
            for (let i = 0; i < row?.userPaymentDetails.length; i++) {
              const p = row?.userPaymentDetails[i];
              totalCashSales = totalCashSales + p.amount;
            }

            const expectedTotalCash = row?.startCashOnSiteAmount + totalCashSales;
            const difference = typeof row?.endCashOnSiteAmount == "number" ? row?.endCashOnSiteAmount - expectedTotalCash : null;

            return difference !== null && difference !== 0 ? (
              <span style={{ color: "red" }}>{difference?.toLocaleString()}</span>
            ) : (
              difference?.toLocaleString()
            );
          },
          sortable: true,
        },
        {
          name: "Balance Issue Reason",
          selector: (row) => <span style={{ color: "coral" }}>{row.balanceIssueReason}</span>,
          sortable: true,
        },
        {
          name: "Closed By",
          selector: (row) => row.sessionClosedBy?.name || "",
          sortable: true,
        },
        {
          name: "Assigned To Confirm",
          selector: (row) => row.assignedStaffToConfirm?.name || "",
          sortable: true,
        },
        {
          name: "Confirmed By",
          selector: (row) => row.cashOnSiteConfirmedBy?.name || "",
          sortable: true,
        },
        {
          name: "Actions",
          selector: (row) => {
            const userId = store.getState().login.loginUser.id;
            const role = store.getState().login.loginUser.role;
            const {permissions,subAdminPermissions,subAdminType} = store.getState().permissions;

            const isAdmin = ADMIN_ROLES.includes(role);
            const hasPermission=(perm)=>(role === "STAFF" && permissions[perm])||(subAdminType === "SUB_ADMIN" && subAdminPermissions[perm])||(isAdmin&&subAdminType!=="SUB_ADMIN")

            if (row?.status == "CONFIRMED") {
              return;
            }
            if (row?.status == "ACTIVE" && (isAdmin || ( userId == row.createdBy?.id || hasPermission("SW-CLS")))) {
              return (
                <ConfirmCloseStaffSessionActionButton staffSessionId={row.id} actionType={"End"}/>
              );
            }
            if (row?.status == "CLOSED" && (isAdmin || (userId == row.assignedStaffToConfirm?.id || ((userId != row.createdBy?.id) && hasPermission("SW-CON"))))) {
              return (
                <ConfirmCloseStaffSessionActionButton staffSessionId={row.id} actionType={"Confirm"}/>
              );
            }
          },
          sortable: true,
        },
      ],
    },
  ],
  followupProgramTracking: [
    {
      id: 1,
      title: "Follow-up Program Tracking",
      columns: [
        {
          name: "Assigned Trainer",
          selector: (row) => row.assignedTrainer || "-",
          sortable: true,
        },
        {
          name: "Package",
          selector: (row) => row.packageName || "-",
          sortable: true,
        },
        {
          name: "Member Name",
          selector: (row) => row.memberName || "-",
          sortable: true,
        },
        {
          name: "Record Type",
          selector: (row) => row.recordType || "-",
          sortable: true,
          cell: (row) => {
            // If recordType is "Workout" and workoutId exists, make it clickable
            if (row.recordType === "Workout" && row.workoutId) {
              const handleWorkoutClick = () => {
                // Get the current origin (protocol + domain)
                const origin = window.location.origin;
                // Redirect to the workout page
                window.location.href = `${origin}/gym-panel/wod/${row.workoutId}`;
              };

              return (
                <span
                  style={{
                    color: "blue",
                    textDecoration: "underline",
                    cursor: "pointer"
                  }}
                  onClick={handleWorkoutClick}
                >
                  Workout
                </span>
              );
            }

            // For all other cases, display as normal text
            return row.recordType || "-";
          },
        },
        {
          name: "AI Evaluation %",
          selector: (row) => (row.aiEvaluationPercentage == null || isNaN(row.aiEvaluationPercentage)) ? "-" : row.aiEvaluationPercentage,
          sortable: true,
          cell: (row) => {
            if (row.aiEvaluationPercentage == null || isNaN(row.aiEvaluationPercentage)) return "-";
            
            const percentage = row.aiEvaluationPercentage;
            let color = "#000"; // default black
            let backgroundColor = "transparent";
            let fontWeight = "normal";
            
            // Color coding based on ranges
            if (percentage >= 90) {
              // Excellent: 90-100%
              color = "#fff";
              backgroundColor = "#27ae60"; // Green
              fontWeight = "600";
            } else if (percentage >= 75) {
              // Good: 75-89%
              color = "#fff";
              backgroundColor = "#2ecc71"; // Light Green
              fontWeight = "600";
            } else if (percentage >= 60) {
              // Satisfactory: 60-74%
              color = "#fff";
              backgroundColor = "#f39c12"; // Orange
              fontWeight = "600";
            } else if (percentage >= 40) {
              // Poor: 40-59%
              color = "#fff";
              backgroundColor = "#e67e22"; // Dark Orange
              fontWeight = "600";
            } else {
              // Critical: 0-39%
              color = "#fff";
              backgroundColor = "#e74c3c"; // Red
              fontWeight = "600";
            }
            
            return (
              <span
                style={{
                  color: color,
                  backgroundColor: backgroundColor,
                  padding: "5px 12px",
                  borderRadius: "5px",
                  fontWeight: fontWeight,
                  display: "inline-block",
                  minWidth: "55px",
                  textAlign: "center"
                }}
              >
                {percentage}%
              </span>
            );
          },
        },
        {
          name: "AI Feedback",
          selector: (row) => row.aiFeedback ? "View" : "-",
          sortable: true,
          cell: (row) => {
            if (!row.aiFeedback) return "-";
            
            return (
              <div
                style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                onClick={async () => {
                  await store.dispatch(
                    setShowAIFeedbackModal({ 
                      [row.id]: true, 
                      data: row.aiFeedback 
                    })
                  );
                }}
              >
                View Details
                <AIFeedbackModal id={row.id} data={row.aiFeedback} />
              </div>
            );
          },
        },
        {
          name: "Created By",
          selector: (row) => row.createdBy || "-",
          sortable: true,
        },
        {
          name: "Expected Date",
          selector: (row) =>
            row.expectedDate ? moment(row.expectedDate).format("YYYY-MM-DD") : "-",
          sortable: true,
        },
        {
          name: "Actual Entry Date",
          selector: (row) =>
            row.actualEntryDate ? moment(row.actualEntryDate).format("YYYY-MM-DD") : "-",
          sortable: true,
        },
        {
          name: "Status",
          selector: (row) => row.status || "-",
          sortable: true,
        },
        {
          name: "Delay",
          selector: (row) =>
            row.delay ? row.delay : "-",
          sortable: true,
        },
        {
          name: "Sent Emails",
          selector: (row) => row.sentEmails || "-",
          sortable: true,
        },
      ],
    },
  ],
};

const tabsComponent = {
  members: [
    {
      id: 1,
      showTotal: true,
      option: totalOptions.Members,
      component: <ReportsTable columns={tabs.members[0].columns} withExtraCols={true} />,
    },
    {
      id: 2,
      showTotal: true,
      option: totalOptions.Memberships,
      component: <ReportsTable columns={tabs.members[1].columns} />,
    },
  ],
  attendence: [
    {
      id: 1,
      component: <ReportsTable columns={tabs.attendence[0].columns} />,
    },
    {
      id: 2,
      component: <ReportsTable columns={tabs.attendence[1].columns} />,
    },
    {
      id: 3,
      component: (
        <CollapsibleTable
          columns={tabs.attendence[2].columns}
          data={dayOfWeek}
        />
      ),
    },
  ],
  sales: [
    {
      id: 1,
      showTotal: true,
      option: totalOptions.Sales,
      component: (
        <ReportsTable
          columns={tabs.sales[0].columns}
          clickedRow={
            store.getState().login.loginUser.role === "STAFF" ||
              store.getState().permissions.subAdminType === "SUB_ADMIN"
              ? // Array of permissions to check
              [
                "S-MVH-V",
                "S-MAC-P-V",
                "S-M-ADD",
                "S-M-MNG",
                "EXT-END-S",
                "S-EXP",
                "S-IMP",
                "S-VOI-SA",
                "S-RET-SA",
                "ED-SA",
                "S-F/U",
              ].some((permission) =>
                store.getState().login.loginUser.role === "STAFF"
                  ? store.getState().permissions.permissions[permission]
                  : store.getState().permissions.subAdminPermissions[
                  permission
                  ]
              )
              : true
          }
        />
      ),
    },
    // {
    //   id: 2,
    //   component: <ReportsTable columns={tabs.sales[1].columns} />,
    // },
  ],
  payroll: [
    {
      id: 1,
      showTotal: false,
      // option: totalOptions.Sales,
      component: <ReportsTable columns={tabs.payroll[0].columns} />,
    },
    // {
    //   id: 2,
    //   component: <ReportsTable columns={tabs.sales[1].columns} />,
    // },
  ],
  staff: [
    {
      id: 1,
     showTotal: false,
      component: <ReportsTable columns={tabs.staff[0].columns} />,
    },
  ],
  accountsBalance: [
    {
      id: 1,
      showTotal: true,
      option: totalOptions.AccountBalance,
      component: <ReportsTable columns={tabs.accountsBalance[0].columns} />,
    },
  ],
  booking: [
    {
      id: 1,
      component: <ReportsTable columns={tabs.booking[0].columns} />,
    },
  ],
  revenue: [
    {
      id: 1,
      showTotal: true,
      option: totalOptions.Revenue,
      component: <ReportsTable columns={tabs.revenue[0].columns} key={"revenueGym"} />,
    },
    {
      id: 2,
      showTotal: true,
      option: totalOptions.PTRevenue,
      component: <ReportsTable columns={tabs.revenue[1].columns} key={"ptRevenue"}/>,
    },
    {
      id: 3,
      showTotal: true,
      option: totalOptions.Revenue,
      component: <ReportsTable columns={tabs.revenue[2].columns} key={"classRevenue"}/>,
    },
  ],
  transaction: [
    {
      id: 1,
      showTotal: true,
      option: totalOptions.Transaction,

      component: <ReportsTable columns={tabs.transaction[0].columns} />,
    },
  ],
  canceledMemberships: [
    {
      id: 1,
      // showTotal: true,
      component: <ReportsTable columns={tabs.canceledMemberships[0].columns} />,
    },
  ],
  accountEntry: [
    {
      id: 1,
      showTotal: true,
      option: totalOptions.AccountingEntry,
      component: <ReportsTable columns={tabs.accountEntry[0].columns} />,
    },
  ],
  staffSessions: [
    {
      id: 1,
      showTotal: false,
      // option: totalOptions.Sales,
      component: (
        <ReportsTable
          columns={tabs.staffSessions[0].columns}
          clickedRow={false}
        />
      ),
    },
  ],
  followupProgramTracking: [
    {
      id: 1,
      showTotal: false,
      component: (
        <ReportsTable
          columns={tabs.followupProgramTracking[0].columns}
          clickedRow={false}
        />
      ),
    },
  ],
};

export const getClassesList = async () => {
  let url = `class/getBasicClassesInfo`;
  let res = await api(url, {}, "get").catch((err) => { });
  let options = res.data.data.map((el) => {
    return {
      label: el.name,
      value: el.name,
    };
  });
  return options;
};
export const getClassesForRevenueList = async () => {
  let url = `class/getBasicClassesInfo`;
  let res = await api(url, {}, "get").catch((err) => { });
  let options = res.data.data.map((el) => {
    return {
      label: el.name,
      value: el.groupId,
    };
  });
  return options;
};
export const getPackagesList = async ({status="active",planType="all"}) => {
  let url = `packages/list?isActive=${status}&planType=${planType}`;
  let res = await api(url, {}, "get").catch((err) => { });
  let options = res.data.data.map((el) => {
    return {
      label: el.name,
      value: el.id,
    };
  });
  return options;
};

export const getTrainersList = async () => {
  let url = `trainer?gym=${JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))?.gym
    }&page=1&limit=999`;
  let res = await api(url, {}, "get").catch((err) => { });
  console.log({ res });
  let options = res.data.data.map((el) => {
    return {
      label: el.user_name,
      value: el.id,
    };
  });
  return options;
};
export const getPayrateTypesList = async () => {
  let url = `payrate-types`;
  let res = await api(url, {}, "get").catch((err) => { });
  console.log({ res });
  let options = res.data.data.map((el) => {
    return {
      label: el.name,
      value: el.id,
    };
  });
  return options;
};

export const getProductsList = async () => {
  let url = `products?limit=9999999&page=1`;
  let res = await api(url, {}, "get").catch((err) => { });
  let options = res.data.data.map((el) => {
    return {
      label: el.name,
      value: el.id,
    };
  });
  return options;
};
export const getStaffsList = async () => {
  let url = `users?page=1&limit=999`;
  let res = await api(url, {}, "get").catch((err) => { });
  let options = res.data.data.map((el) => {
    return {
      label: el.name,
      value: el.id,
    };
  });

  return options;
};
export const getAssignedProductsSellers = async () => {
  let url = `products/unique/sellers`;
  let res = await api(url, {}, "get").catch((err) => { });
  let options = res.data.data.map((el) => {
    return {
      label: el.name,
      value: el.id,
    };
  });

  return options;
};

export const getUniqueSupplier = async () => {
  await store.dispatch(getUniqueSuppliers());
  let res = store.getState().product.suppliers;
  let options = res?.map((el) => {
    return {
      label: el,
      value: el,
    };
  });

  return options;
};

export const getCategories = async () => {
  await store.dispatch(getGymCategories());
  let res = store.getState().gym.categories;
  let options = res?.map((el) => {
    return {
      label: el,
      value: el,
    };
  });

  return options;
};
export const getPtTypes = async () => {
  await store.dispatch(getAppointmentTypes());
  let res = store.getState().packages.appointmentTypes;
  let options = res?.map((el) => {
    return {
      label: el.name,
      value: el.id,
    };
  });

  return options;
};

export const getCashList = () => {
  return cashesList;
};

export const getStaffSessionsStatusList = () => {
  return [
    {
      value: "ACTIVE",
      label: "ACTIVE",
    },
    {
      value: "CLOSED",
      label: "CLOSED",
    },
    {
      value: "CONFIRMED",
      label: "CONFIRMED",
    },
  ];
};

export const filtersOptions = {
  gender: [
    {
      label: "Male",
      value: "M",
    },
    {
      label: "Female",
      value: "F",
    },
  ],
  relationType: [
    {
      label: "Parent",
      value: "parent",
    },
    {
      label: "Child",
      value: "child",
    },
  ],
  status: [
    {
      label: "Active",
      value: "active",
    },
    {
      label: "Inactive",
      value: "inactive",
    },
    {
      label: "Freezed",
      value: "freezed",
    },
  ],
    AllMembershipStatus: [
    {
      label: "ACTIVE",
      value: "active",
    },
    {
      label: "EXPIRED",
      value: "expired",
    },
    {
      label: "FREEZED",
      value: "freezed",
    },
  ],
  memberStatus: [
    {
      label: "New (purchase a package)",
      value: "NEW_WITH_PACKAGE",
    },
        {
      label: "New (no package purchase)",
      value: "NEW_NO_PACKAGE",
    },
    
    {
      label: "Expired",
      value: "EXPIRED",
    },
    {
      label: "Renew",
      value: "RENEWED",
    },
    {
      label: "Existing",
      value: "EXISTING",
    },
    {
      label: "Rejoined",
      value: "REJOINED",
    },
    {
      label: "Deleted",
      value: "DELETED",
    },
    {
      label: "Freezed",
      value: "FREEZED",
    },
    {
      label: "Active",
      value: "ACTIVE",
    },
    {
      label: "InActive",
      value: "INACTIVE",
    },
  ],
  services: [
    {
      label: "Classes",
      value: "class",
    },
    {
      label: "Appointments",
      value: "appointment",
    },
  ],
  paymentTypes: [
    {
      label: "Cash",
      value: "L",
    },
    {
      label: "Check",
      value: "CQ",
    },
    {
      label: "Complimentary",
      value: "CO",
    },
    {
      label: "Visa",
      value: "CC",
    },
  ],
  canceledMemberships: [
    {
      label: "Upgrade",
      value: "upgrade",
    },
    {
      label: "Void",
      value: "void",
    },
  ],
  classesAttendence: [],
};

export const reportsList = [
  {
    key: 1,
    title: "Sales",
    isActive: true,
    icon: <InvoiceLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/sales",
    tabbed: true,
    tabs: tabs.sales,
    tabTitle: ["sales"],
    tabsComponent: tabsComponent.sales,
    reportParam: ["gymSalesReport"],
    totalOptions: totalOptions.Sales,
    showTotal: true,
    show: () => {
      if (!store.getState().gym?.gymConfig?.reports?.enabled || !store.getState().gym?.gymConfig?.reports?.salesReport?.enabled) {
        return false;
      }
      if (
        (store.getState().login.loginUser.role === "STAFF" &&
          !store.getState().permissions.permissions["S-SA-RE"]) ||
        (store.getState().permissions.subAdminType === "SUB_ADMIN" &&
          !store.getState().permissions.subAdminPermissions["S-SA-RE"])
      )
        return false;
      else return true;
    },
  },
  {
    key: 2,
    title: "Members",
    isActive: true,
    icon: <ClassesLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/members",
    tabbed: true,
    tabs: tabs.members,
    tabsComponent: tabsComponent.members,
    tabTitle: ["members", "memberships"],
    reportParam: ["membersReport/member", "membersReport/membership"],
    totalOptions: totalOptions.Members,
    showTotal: true,
    withExtraCols: [true, false],
    show: () => {
      if (!store.getState().gym?.gymConfig?.reports?.enabled || !store.getState().gym?.gymConfig?.reports?.membersReport?.enabled) {
        return false;
      }
      if (
        (store.getState().login.loginUser.role === "STAFF" &&
          !store.getState().permissions.permissions["S-ME-RE"]) ||
        (store.getState().permissions.subAdminType === "SUB_ADMIN" &&
          !store.getState().permissions.subAdminPermissions["S-ME-RE"])
      )
        return false;
      else return true;
    },
  },
  {
    key: 3,
    title: "Retention",
    isActive: true,
    icon: <RetentionLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/retention",
    tabTitle: ["retention"],
    tabbed: false,
    reportParam: ["retention"],
    hideDateFilters: true,
    columns: [
      {
        name: "Instructor Name",
        selector: (row) => row.InstructorName || "MockData",
        sortable: true,
      },
      {
        name: "Service",
        selector: (row) => row.ServiceName || "MockData",
        sortable: true,
      },
      {
        name: "Service Type",
        selector: (row) => row.ServiceType || "MockData",
        sortable: true,
      },
      {
        name: "Total Members",
        selector: (row) => row.TotalMember || "MockData",
        sortable: true,
      },
    ],
    show: () => {
      return false;
      // if (
      //   (store.getState().login.loginUser.role === "STAFF" &&
      //     !store.getState().permissions.permissions["S-RT-RE"]) ||
      //   store.getState().gym?.gym?.subscriptionPlan?.id == 1
      // )
      //   return false;
      // else return true;
    },
  },
  {
    key: 7,
    title: "Revenue",
    isActive: true,
    icon: <RevenueLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/revenue",
    // reportParam: ["revenue"],
    // tabTitle: ["revenue"],
    tabbed: true,
    tabs: tabs.revenue,
    tabsComponent: tabsComponent.revenue,
    tabTitle: ["Gym subscriptions Revenue", "PT subscriptions Revenue","Class subscriptions Revenue"],
    reportParam: ["revenue/GYM", "revenue/pt","revenue/class"],
    totalOptions: totalOptions.Revenue,
    showTotal: true,
    show: () => {
      if (!store.getState().gym?.gymConfig?.reports?.enabled || !store.getState().gym?.gymConfig?.reports?.revenueReport?.enabled) {
        return false;
      }
      if (
        (store.getState().login.loginUser.role === "STAFF" &&
          !store.getState().permissions.permissions["S-REV-RE"]) ||
        (store.getState().permissions.subAdminType === "SUB_ADMIN" &&
          !store.getState().permissions.subAdminPermissions["S-REV-RE"]) ||
        store.getState().gym?.gym?.subscriptionPlan?.id == 1
      )
        return false;
      else return true;
    },
  },
  {
    key: 4,
    title: "Attendance Analysis",
    isActive: true,
    icon: <AnalyticsLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/attendence-analysis",
    tabbed: true,
    tabs: tabs.attendence,
    tabTitle: ["Instructor", "Classes", "Gym"],
    tabsComponent: tabsComponent.attendence,
    hideDateFilters: [true, false, false],
    reportParam: [
      "attendence/instructor",
      "attendence/classes",
      "attendence/gym",
    ],
    show: () => {
      return false;
      // if (
      //   (store.getState().login.loginUser.role === "STAFF" &&
      //     !store.getState().permissions.permissions["S-ATT-A-RE"]) ||
      //   (store.getState().permissions.subAdminType === "SUB_ADMIN" &&
      //     !store.getState().permissions.subAdminPermissions["S-ATT-A-RE"]) ||
      //   store.getState().gym?.gym?.subscriptionPlan?.id == 1
      // )
      //   return false;
      // else return false;
    },
  },
  {
    key: 5,
    title: "Booking",
    isActive: true,
    icon: <CalendarLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/booking",
    tabbed: false,
    reportParam: ["booking"],
    tabTitle: ["Booking"],
    tabs: tabs.booking,
    tabsComponent: tabsComponent.booking,
    hideDateFilters: true,
    columns: [
      {
        name: "Instructor Name",
        selector: (row) => row.InstructorName || "MockData",
        sortable: true,
      },
      {
        name: "Service",
        selector: (row) => row.ServiceName || "MockData",
        sortable: true,
      },
      {
        name: "Service Type",
        selector: (row) => row.ServiceType || "MockData",
        sortable: true,
      },
      {
        name: "Total Members",
        selector: (row) => row.TotalMember || "MockData",
        sortable: true,
      },
    ],
    show: () => {
      if (!store.getState().gym?.gymConfig?.reports?.enabled || !store.getState().gym?.gymConfig?.reports?.bookingReport?.enabled) {
        return false;
      }
      if (
        (store.getState().login.loginUser.role === "STAFF" &&
          !store.getState().permissions.permissions["S-BO-RE"]) ||
        (store.getState().permissions.subAdminType === "SUB_ADMIN" &&
          !store.getState().permissions.subAdminPermissions["S-BO-RE"]) ||
        store.getState().gym?.gym?.subscriptionPlan?.id == 1
      )
        return false;
      else return true;
    },
  },
  {
    key: 6,
    title: "Account Balance",
    isActive: true,
    icon: <WalletLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/AccountBalance",
    tabbed: true,
    tabs: tabs.accountsBalance,
    tabsComponent: tabsComponent.accountsBalance,
    reportParam: ["accountBalance"],
    tabTitle: ["AccountBalance"],
    showTotal: true,
    hideDateFilters: true,
    totalOptions: totalOptions.AccountBalance,
    show: () => {
      if (!store.getState().gym?.gymConfig?.reports?.enabled || !store.getState().gym?.gymConfig?.reports?.accountBalanceReport?.enabled) {
        return false;
      }
      if (
        (store.getState().login.loginUser.role === "STAFF" &&
          !store.getState().permissions.permissions["S-ACC-RE"]) ||
        (store.getState().permissions.subAdminType === "SUB_ADMIN" &&
          !store.getState().permissions.subAdminPermissions["S-ACC-RE"]) ||
        store.getState().gym?.gym?.subscriptionPlan?.id == 1
      )
        return false;
      else return true;
    },
  },

  {
    key: 8,
    title: "Staff",
    isActive: true,
    icon: <StaffLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/staff",
    tabbed: true,
    tabs: tabs.staff,
    reportParam: ["staff"],
    tabTitle: ["Staff Log"],
    tabsComponent: tabsComponent.staff,
    hideDateFilters: false,
    show: () => {
      if (!store.getState().gym?.gymConfig?.manageStaff?.enabled) {
        return false;
      }
      if (
        (store.getState().login.loginUser.role === "STAFF" &&
          !store.getState().permissions.permissions["S-STA-RE"]) ||
        (store.getState().permissions.subAdminType === "SUB_ADMIN" &&
          !store.getState().permissions.subAdminPermissions["S-STA-RE"])
      )
        return false;
      else return true;
    },
  },
  {
    key: 9,
    title: "Transaction",
    isActive: true,
    icon: <TransactionLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/transaction",
    tabbed: true,
    tabs: tabs.transaction,
    totalOptions: totalOptions.Revenue,
    reportParam: ["transaction"],
    tabTitle: ["Transaction Log"],
    tabsComponent: tabsComponent.transaction,
    hideDateFilters: false,
    show: () => {
      if (!store.getState().gym?.gymConfig?.reports?.enabled || !store.getState().gym?.gymConfig?.reports?.transactionsReport?.enabled) {
        return false;
      }
      if (
        (store.getState().login.loginUser.role === "STAFF" &&
          !store.getState().permissions.permissions["S-VTR"]) ||
        (store.getState().permissions.subAdminType === "SUB_ADMIN" &&
          !store.getState().permissions.subAdminPermissions["S-VTR"]) ||
        store.getState().gym?.gym?.subscriptionPlan?.id == 1
      )
        return false;
      else return true;
    },
  },
  {
    key: 9,
    title: "Canceled Memberships",
    isActive: true,
    icon: <TransactionLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/canceled-memberships",
    tabbed: true,
    tabs: tabs.canceledMemberships,
    totalOptions: totalOptions.Revenue,
    reportParam: ["canceledMemberships"],
    tabTitle: ["Canceled Memberships Log"],
    tabsComponent: tabsComponent.canceledMemberships,
    hideDateFilters: false,
    show: () => {
      if (!store.getState().gym?.gymConfig?.reports?.enabled || !store.getState().gym?.gymConfig?.reports?.canceledMembershipsReport?.enabled) {
        return false;
      }
      return true;
    },
  },
  {
    key: 11,
    title: "Accounting Entry",
    isActive: true,
    icon: <InvoiceLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/accountingEntry",
    tabbed: true,
    tabs: tabs.accountEntry,
    tabTitle: ["accountEntry"],
    tabsComponent: tabsComponent.accountEntry,
    reportParam: ["accountingEntry"],
    totalOptions: totalOptions.AccountingEntry,
    showTotal: true,
    show: () => {
      if (!store.getState().gym?.gymConfig?.reports?.enabled || !store.getState().gym?.gymConfig?.reports?.accountingEntryReport?.enabled) {
        return false;
      }
      if (
        (store.getState().login.loginUser.role === "STAFF" &&
          !store.getState().permissions.permissions["S-AER"]) ||
        (store.getState().permissions.subAdminType === "SUB_ADMIN" &&
          !store.getState().permissions.subAdminPermissions["S-AER"]) ||
        store.getState().gym?.gym?.subscriptionPlan?.id == 1
      )
        return false;
      else return true;
    },
  },
  {
    key: 11,
    title: "Staff Sessions",
    isActive: true,
    icon: <InvoiceLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/staffSessions",
    tabbed: true,
    tabs: tabs.staffSessions,
    tabTitle: ["Staff Sessions"],
    tabsComponent: tabsComponent.staffSessions,
    reportParam: ["staffSessions"],
    totalOptions: totalOptions.StaffSessions,
    // showTotal: false,
    show: () => {
      if (!store.getState().gym?.gymConfig?.switchStaff?.enabled) {
        return false;
      }

      if (
        (store.getState().login.loginUser.role === "STAFF" &&
          !store.getState().permissions.permissions["S-SA-RE"]) ||
        (store.getState().permissions.subAdminType === "SUB_ADMIN" &&
          !store.getState().permissions.subAdminPermissions["S-SA-RE"])
      )
        return false;
      else return true;
    },
  },
  {
    key: 12,
    title: "Follow-up Program Tracking",
    isActive: true,
    icon: <InvoiceLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/followupProgramTracking",
    tabbed: true,
    tabs: tabs.followupProgramTracking,
    tabTitle: ["Follow-up Program Tracking"],
    tabsComponent: tabsComponent.followupProgramTracking,
    reportParam: ["followupProgramTracking"],
    totalOptions: totalOptions.FollowupProgramTracking,
    show: () => {
      if (!store.getState().gym?.gymConfig?.followupProgram?.enabled) {
          return false;
      }
      return true;

    },
  },
  {
    key: 1,
    title: "Payroll",
    isActive: true,
    icon: <InvoiceLogo color="#EBA607" />,
    msg: "Under construction",
    path: "reports/payroll",
    tabbed: true,
    tabs: tabs.sales,
    tabTitle: ["payroll"],
    tabsComponent: tabsComponent.payroll,
    reportParam: ["payroll"],
    // totalOptions: totalOptions.Sales,
    showTotal: false,
    show: () => {
      if (!store.getState().gym?.gymConfig?.payroll?.enabled) {
        return false;
      }
      if (
        (store.getState().login.loginUser.role === "STAFF" &&
          !store.getState().permissions.permissions["S-PAY-RE"]) ||
        (store.getState().permissions.subAdminType === "SUB_ADMIN" &&
          !store.getState().permissions.subAdminPermissions["S-PAY-RE"])
      )
        return false;
      else return true;
    },
  },
];

export const getReport = ({ reportObject, activeTab, pagination }) => {
  let Report = reportObject.tabsComponent[activeTab - 1];
  return Report;
};

export const exportButtonStyles = {
  padding: "5px 2px",
  background: "#4D4467",
  borderRadius: "8px",
};

export const reportsFiltersButtonStyles = {
  padding: "5px 2px",
  background: "#4D4467",
  borderRadius: "8px",
};
const getBranchesList = (branches) => {
  return FormatObjects(branches, "name")

}
export const getFiltersForCurrentReport = (reportName) => {
  switch (reportName) {
    case "members": {
      let arr = [
               {
          title: "Member Status",
          key: "memberStatus",
          options: [...filtersOptions.memberStatus],
        },
        {
          title: "Gender",
          key: "gender",
          options: filtersOptions.gender,
        },
        {
          title: "Relation Type",
          key: "relationType",
          options: filtersOptions.relationType,
        },
 
        {
          title: "Created By",
          key: "createdBy",
        },

      ];
      const state = store.getState();
      const shouldShowBranch =
        state.gym?.gym?.superGymAdmin?.gyms?.length > 0;
      console.log({ state })

      if (shouldShowBranch) {
        arr.push({
          title: "Branch",
          key: "branch",
          options: getBranchesList(state.gym?.gym?.superGymAdmin?.gyms),
        });
      }
      return arr
    }
    case "memberships": {
      return [

        {
          title: "Member Status",
          key: "memberStatus",
          options: [...filtersOptions.memberStatus]        },
                  {
          title: "Status",
          key: "status",
          options: filtersOptions.status,
        },
      ];
    }
    case "retention": {
      return [
        {
          title: "Serivce",
          key: "services",
          options: filtersOptions.services,
        },
      ];
    }
    case "AccountBalance": {
      return [
        {
          title: "Client",
          key: "search",
        },
      ];
    }
    case "Staff Log": {
      return [
        {
          title: "Staff",
          key: "search",
        },
      ];
    }
    case "Classes": {
      return [
        {
          title: "Class",
          key: "search",
          options: filtersOptions.classesAttendence,
          list: true,
          getList: getClassesList,
        },
      ];
    }
    case "Instructor": {
      return [
        {
          title: "Serivce",
          key: "services",
          options: filtersOptions.services,
          list: false,
        },
      ];
    }
    case "Booking": {
      return [
        {
          title: "Serivce",
          key: "services",
          options: filtersOptions.services,
        },
      ];
    }
    case "sales": {
      return [
        // {
        //   title: "Created By",
        //   key: "createdBy",
        //   options: [],
        //   list: true,
        //   getList: getStaffsList,
        // },
        // {
        //   title: "Assigned Product Sale By",
        //   key: "assignedUser",
        //   options: [],
        //   list: true,
        //   getList: getStaffsList,
        // },
        // {
        //   title: "Trainer",
        //   key: "trainer",
        //   options: [],
        //   list: true,
        //   getList: getTrainersList,
        // },
        // {
        //   title: "Payment Type",
        //   key: "paymentType",
        //   options: filtersOptions.paymentTypes,
        //   list: false,
        // },
        // {
        //   title: "Supplier",
        //   key: "supplier",
        //   options: [],
        //   list: true,
        //   getList: getUniqueSupplier,
        // },
        // {
        //   title: "Category",
        //   key: "category",
        //   options: [],
        //   list: true,
        //   getList: getCategories,
        // },
      ];
    }
    case  "Class subscriptions Revenue": {
      return [
        {
          title: "Status",
          key: "status",
          options: filtersOptions.AllMembershipStatus,
        },
        {
          title: "Classes",
          key: "class",
          options: filtersOptions.classesAttendence,
          list: true,
          getList: getClassesForRevenueList,
        },

        {
          title: "Instructor",
          key: "trainer",
          options: [],
          list: true,
          getList: getTrainersList,
        },
      ];
    }
    case  "PT subscriptions Revenue": {
      return [
        {
          title: "Status",
          key: "status",
          options: filtersOptions.AllMembershipStatus,
        },

        {
          title: "Instructor",
          key: "trainer",
          options: [],
          list: true,
          getList: getTrainersList,
        },
      ];
    }
    case "Canceled Memberships Log": {
      return [
        {
          title: "Voided By",
          key: "voidBy",
        },
        // {
        //   title: "Package",
        //   key: "package",
        //   options: [],
        //   list: true,
        //   getList: ()=>getPackagesList({status:"all"}),
        // },
        {
          title: "Type",
          key: "type",
          options: filtersOptions.canceledMemberships,
        },
        // {
        //   title: "Payment Type",
        //   key: "paymentType",
        //   options: filtersOptions.paymentTypes,
        //   list: false,
        // },
      ];
    }
    case "payroll": {
      return [
        {
          title: "Trainer",
          key: "trainer",
          options: [],
          list: true,
          getList: getTrainersList,
        },
        {
          title: "Payrate Type",
          key: "payrateType",
          options: [],
          list: true,
          getList: getPayrateTypesList,
        },
      ];
    }
    case "accountEntry": {
      return [

      ];
    }
    case "Staff Sessions": {
      return [
        {
          title: "Created By",
          key: "createdBy",
          options: [],
          list: true,
          getList: getStaffsList,
        },
        {
          title: "Closed By",
          key: "sessionClosedBy",
          options: [],
          list: true,
          getList: getStaffsList,
        },
        {
          title: "Status",
          key: "status",
          options: [],
          list: true,
          getList: getStaffSessionsStatusList,
        },
        {
          title: "Cash",
          key: "cashId",
          options: [],
          list: true,
          getList: getCashList,
        }
      ];
    }

    default: {
      return [
        // {
        //   title: "Start Date",
        //   key: "startDate",
        //   options: null,
        // },
        // {
        //   title: "End Date",
        //   key: "endDate",
        //   options: null,
        // },
      ];
    }
  }
};

// For Exports

export const values = {
  revenue: {
    "Gym subscriptions Revenue": {
      Member: (row) => row.memberName,
      Service: (row) => row.packageName,
      "Created Date": (row) => moment(row?.createdAt).format("YYYY-MM-DD"),
      "Start Date": (row) => moment(row?.startDate).format("YYYY-MM-DD"),
      "End Date": (row) => moment(row?.endDate).format("YYYY-MM-DD"),
      Type: (row) => packTypes[row.planType],
      Price: (row) => row.purchasedPackagePrice,
      Discount: (row) => row.discount,
      "Tax (%)": (row) => row.tax,
      "Tax amount": (row) => row.taxAmount,
      "Net Rev.": (row) => row.netRevenue,
      Used: (row) => row.usedSessions || 0,
      Remaining: (row) => row.remainingSessions,
      "Earned $": (row) => parseFloat(row.earned?.toFixed(2) || 0),
      "Deffered $": (row) => parseFloat(row.deffered?.toFixed(2) || 0),
      Notes: (row) =>
        row.isvoided ? "Voided" : row.isUpgraded ? "Upgraded" : "N/A",
      isMemberDeleted: (row) => (row.isDeleted ? "DELETED" : "--"),
    },
     "PT subscriptions Revenue": {
      Member: (row) => row.memberName,
      Service: (row) => row.packageName,
      "Created Date": (row) => moment(row?.createdAt).format("YYYY-MM-DD"),
      "Start Date": (row) => moment(row?.startDate).format("YYYY-MM-DD"),
      "End Date": (row) => moment(row?.endDate).format("YYYY-MM-DD"),
      Type: (row) => packTypes[row.planType],
      Price: (row) => row.purchasedPackagePrice,
      Discount: (row) => row.discount,
      "Tax (%)": (row) => row.tax,
      "Tax amount": (row) => row.taxAmount,
      "Net Rev.": (row) => row.netRevenue,
      "Booked Sessions": (row) => row.usedSessions || 0,
      "Completed Sessions": (row) =>  row?.completedBookingsCount || 0,
      "Attended Sessions ": (row) => row?.checkedInCount || 0,
       Remaining: (row) => row.remainingSessions,
      "Earned from Completed Sessions $": (row) => parseFloat(row.earned?.toFixed(2) || 0),
      "Earned Value (from Attended) Sessions $": (row) => parseFloat(row.earnedFromCheckIn?.toFixed(2) || 0),
      "Deffered from Completed Sessions $": (row) => parseFloat(row.deffered?.toFixed(2) || 0),
      "Deffered (from Attended) Sessions $": (row) => parseFloat(row.defferedFromCheckIn?.toFixed(2) || 0),
      "Instructor Name":(row)=> row.trainerName || "Sale Not Assigend To Instructor",
      Notes: (row) =>
        row.isvoided ? "Voided" : row.isUpgraded ? "Upgraded" : "N/A",
      isMemberDeleted: (row) => (row.isDeleted ? "DELETED" : "--"),
    },
     "Class subscriptions Revenue": {
      Member: (row) => row.memberName,
      Service: (row) => row.packageName,
      "Created Date": (row) => moment(row?.createdAt).format("YYYY-MM-DD"),
      "Start Date": (row) => moment(row?.startDate).format("YYYY-MM-DD"),
      "End Date": (row) => moment(row?.endDate).format("YYYY-MM-DD"),
      Type: (row) => packTypes[row.planType],
      Price: (row) => row.purchasedPackagePrice,
      Discount: (row) => row.discount,
      "Tax (%)": (row) => row.tax,
      "Tax amount": (row) => row.taxAmount,
      "Net Rev.": (row) => row.netRevenue,
      Used: (row) => row.usedSessions || 0,
      Remaining: (row) => row.remainingSessions,
      "Earned $": (row) => parseFloat(row.earned?.toFixed(2) || 0),
      "Deffered $": (row) => parseFloat(row.deffered?.toFixed(2) || 0),
      "Instructor Name":(row)=> row.trainerName || "Sale Not Assigend To Instructor",
      "Class Name":(row)=> row.className || "",
      Notes: (row) =>
        row.isvoided ? "Voided" : row.isUpgraded ? "Upgraded" : "N/A",
      isMemberDeleted: (row) => (row.isDeleted ? "DELETED" : "--"),
    },
  },
  sales: {
    sales: {
      "Sale Date": (row) => moment(row.createdAt).format("DD-MM-YYYY hh:mm:ss A"),
      Time: (row) => moment(row.createdAt).format("hh:mm A"),
      Client: (row) => row?.memberName,
      "Ref ID": (row) => row?.refId,
      Package: (row) => row?.packageName,
      Quantity: (row) => 1,
      Price: (row) => row.purchasedPackagePrice,
      Subtotal: (row) => {
        const { purchasedPackagePrice, discount } = row;
        const discountAmount = (purchasedPackagePrice * discount) / 100;
        return purchasedPackagePrice - discountAmount;
      },
      Cost: (row) => row?.cost || 0,
      "Payment Type": (row) => {
        let type;
        switch (row.paymentType) {
          case "CC":
            type = "Visa";
            break;
          case "L":
            type = "Cash";
            break;
          case "BA":
            type = "Bank";
            break;
          case "CO":
            type = "Complimentary";
            break;
          case "SP":
            type = "Split";
            break;
          default:
            type = "";
        }
        return `${type}`;
      },

      Category: (row) => row?.category,
      Discount: (row) => {
        return parseFloat(
          (
            (row.discount * row.purchasedPackagePrice * row.quantity) /
            100
          ).toFixed(2)
        );
      },
      Tax: (row) =>
        parseFloat(
          (
            row?.purchasedPackagePrice -
            row?.purchasedPackagePrice / (1 + row?.tax / 100)
          ).toFixed(2)
        ),
      Net: (row) => {
        //for Excel
        const taxPercentage = 1 + row.tax / 100;
        const discountedAmount =
          row.purchasedPackagePrice * row.quantity * (1 - row.discount / 100);
        const tax = discountedAmount * (1 - 1 / taxPercentage);
        let netRevenue = discountedAmount - tax;
        netRevenue = parseFloat(netRevenue.toFixed(2));
        return netRevenue;
      },
      Notes: (row) => (row?.isVoided ? "Voided" : "N/A"),
      "Joining Fees": (row) => row?.joiningFees || 0,
      "Assigned Sale Produt": (row) =>
        `${row?.assignedSale ? row.assignedSale : ""}`,
      "Created By": (row) => row?.createdBy || "-----------",
      Trainer: (row) => row?.assignedTrainer || "-------------",
      isMemberDeleted: (row) => (row.isDeleted ? "DELETED" : "--"),
    },
  },
  members: {
    members: {
      ID: (row) => row.id,
      Name: (row) => row.name,
      Email: (row) => row.email,
      Mobile: (row) => row.phone,
      Gender:(row)=>row.gender||"Not Specified",
      "Member Registerd By":(row)=>{
          let registerBy="System"
          if(["F", "G", "T", "D", "A"].includes(row?.loginType))registerBy="App"
          else if (row?.loginType=="SR") registerBy="Self Registration"
          else if (row?.loginType=="TR") registerBy="Trainer"
          return registerBy
      },
      "Member Status": (row) => row?.memberStatus,
      "Total Spent": (row) => row?.totalSpent,
      "Joining Date": (row) =>
        moment(row?.createdAt).format("DD-MM-YYYY hh:mm:ss A"),
      "Last Updating Date": (row) =>
        moment(row?.updatedAt).format("DD-MM-YYYY hh:mm:ss A"),
      isMemberDeleted: (row) => (row.isDeleted ? "DELETED" : "--"),
      "Created By": (row) => row?.createdBy,
      "Member Created Branch": (row) => row?.branchName,
      "Waver Signed": (row) => (row?.isMobileVerfied||row?.isEmailVerified||row.acceptTermsAndConditions? "Yes" : "No"),
    },
    memberships: {
      Member: (row) => row.memberName,
      "Member Phone": (row) => row.phone,
      "Member Email": (row) => row.email,
      "Member Date of Birth": (row) => row?.dob,
      MemberPhone: (row) => row.phone,
      "Member Status":(row)=>row.memberStatus,
      Package: (row) => row.packageName,
      Starts: (row) => moment(row.startDate).format("DD-MM-YYYY hh:mm:ss A"),
      Ends: (row) => moment(row.endDate).format("DD-MM-YYYY hh:mm:ss A"),
      Status: (row) => row.subscriptionStatus,
      isMemberDeleted: (row) => (row.isDeleted ? "DELETED" : "--"),
      "Created By": (row) => row?.createdBy,
      "Check-ins": (row) =>
        `${row.checkins || 0}/${row.sessionCount !== "unlimited"
          ? `${row.sessionCount} Sessions`
          : `${row.durationCount} Days`
        }`,
    },
  },
  retention: {
    retention: {
      "Instructor Name": (row) => row.InstructorName,
      Service: (row) => row.ServiceName,
      "Service Type": (row) => row.ServiceType,
      "Total Members": (row) => row.TotalMember,
    },
  },
  AccountBalance: {
    AccountBalance: {
      "Client Name": (row) => row.name,
      "OutStanding Balance": (row) => row.outstandingBalance,
      "Received Amount": (row) => row.recievedAmount,
      "Total Payment Due": (row) => row.totalPaymentDue,
      isMemberDeleted: (row) => (row.isDeleted ? "DELETED" : "--"),
    },
  },
  staff: {
    "Staff Log": {
      "Staff Name": (row) => row.name,
      "Date":(row)=>moment(Number(row.checkin)).format("DD-MM-YYYY"),
      "Day": (row) => moment(Number(row.checkin)).format("dddd"),
      "Check in": (row) =>
      moment(Number(row?.checkin)).format("HH:mm:ss A"),
      "Check out": (row) =>
        row.checkout &&moment(Number(row.checkout)).format("HH:mm:ss A"),
    },
  },
  "attendence analysis": {
    Instructor: {
      "Instructor Name": (row) => row.InstructorName,
      Service: (row) => row.ServiceName,
      "Service Type": (row) => row.ServiceType,
      "Total Members": (row) => row.TotalMember,
    },
    Classes: {
      Name: (row) => row.name,
      "Day(Time)": (row) => row.dayConverted,
      "Total members": (row) => row.checkinCount,
    },
    Gym: {
      Time: (row) => row.time_range,
      "number of checkins": (row) => row.checkin_count,
    },
  },
  booking: {
    Booking: {
      "Instructor Name": (row) => row.InstructorName,
      Service: (row) => row.ServiceName,
      "Service Type": (row) => row.ServiceType,
      "Total Members": (row) => row.TotalMember,
    },
  },
  transaction: {
    "Transaction Log": {
      id: (row) => row.id,
      membership: (row) => row.membership,
      "Start Subscription": (row) =>
        row.startDate
          ? moment(row.startDate).format("DD-MM-YYYY hh:mm:ss A")
          : "--------",
      "End Subscription": (row) =>
        row?.endDate
          ? moment(row.endDate).format("DD-MM-YYYY hh:mm:ss A")
          : "------------",
      purpose: (row) => row.purpose,
      note: (row) => row?.note || "----",
      isMemberDeleted: (row) => (row.isDeleted ? "DELETED" : "--"),
      type: (row) => {
        let type;
        switch (row.type) {
          case "CC":
            type = row.CCType || "Visa";
            break;
          case "CQ":
            type = "Cheque";
            break;
          case "L":
            type = "Cash";
            break;
          case "CO":
            type = "complimentary";
            break;
          case "BA":
            type = "Bank";
            break;

          default:
            break;
        }
        return type;
      },
      "financial party": (row) => row.financialParty,
      amount: (row) => row.amount,
      "Created By": (row) => row?.name,
      "Created At": (row) =>
        moment(parseInt(row?.createdAt)).format("DD-MM-YYYY hh:mm:ss A"),
    },
  },
  "canceled memberships": {
    "Canceled Memberships Log": {
      id: (row) => row.id,
      Member: (row) => row?.member,
      Package: (row) => row?.package,
      Price: (row) => row?.price,
      "Receieved Amount": (row) => row?.recievedAmount,
      "Voided Amount": (row) => row?.returnedAmoun,
      "Canceled Date": (row) =>
        moment(parseInt(row?.createdAt)).format("DD-MM-YYYY hh:mm:ss A"),
      "Canceled By": (row) => row?.voidedBy,
    },
  },
  staffSessions: {
    "Staff Sessions": {
      "ID": (row) => row?.id || "N/A",
      "Staff Name": (row) => row?.createdBy?.name || "N/A",
      "Cash": (row) => {
        let cashName;
        cashesList.forEach((c) => {
          if (c.id == row.cash) {
            cashName = c.label;
          }
        });
        return cashName || "N/A";
      },
      "Status": (row) => row?.status || "N/A",
      "Start Date": (row) => moment(row.startTime).format("DD-MM-YYYY") || "",
      "End Date": (row) => row.endTime ? moment(row.endTime).format("DD-MM-YYYY") : "",
      "Start Time": (row) => moment(row.startTime).format("hh:mm A") || "",
      "End Time": (row) => row.endTime ? moment(row.endTime).format("hh:mm A") : "",
      "Cash At Start": (row) => row?.startCashOnSiteAmount?.toLocaleString() || 0,
      "Cash At End": (row) => row?.endCashOnSiteAmount?.toLocaleString() || 0,
      "Cash Confirmed Amount": (row) => row?.cashOnSiteConfirmedAmount?.toLocaleString() || 0,
      "Net Transactions": (row) => {
        let total = 0;
        if (row?.userPaymentDetails) {
          for (let i = 0; i < row.userPaymentDetails.length; i++) {
            const p = row.userPaymentDetails[i];
            total = total + p.amount;
          }
        }
        return total?.toLocaleString();
      },
      "Total In Cash": (row) => {
        let total = 0;
        for (let i = 0; i < row?.userPaymentDetails.length; i++) {
          const p = row?.userPaymentDetails[i];
          total = total + p.amount;
        }
        const totalInCash = total + row.startCashOnSiteAmount;
        return totalInCash?.toLocaleString();
      },
      "Difference In Cash": (row) => {
        let totalCashSales = 0;
        if (row?.userPaymentDetails) {
          for (let i = 0; i < row.userPaymentDetails.length; i++) {
            const p = row.userPaymentDetails[i];
            totalCashSales = totalCashSales + p.amount;
          }
        }
        const expectedTotalCash = (row?.startCashOnSiteAmount || 0) + totalCashSales;
        const difference = typeof row?.endCashOnSiteAmount == "number" 
          ? row.endCashOnSiteAmount - expectedTotalCash 
          : null;
        return difference?.toLocaleString();
      },
      "Balance Issue Reason": (row) => row.balanceIssueReason || "",
      "Closed By": (row) => row?.sessionClosedBy?.name || "",
      "Assigned To Confirm": (row) => row?.assignedStaffToConfirm?.name || "",
      "Confirmed By": (row) => row?.cashOnSiteConfirmedBy?.name || "",
    },
  },
};
